interface GetMovingActionViewArgs {
    isDisabled: boolean;
    isYou: boolean;
    getMoving: () => void;
    name: string;
}

const GetMovingActionView: React.FC<GetMovingActionViewArgs> = args => {
    if (!args.isYou) {
        return <li>{args.name}</li>
    }

    return <li><button
        disabled={args.isDisabled}
        onClick={e => {
            args.getMoving();
        }}
    >{args.name}</button></li>
}

export default GetMovingActionView;